import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router'
import Loading from 'src/components/Loading/Loading'
import { FormattedMessage } from 'react-intl'
import { setUserSecret } from 'src/util/helper'

import './Associate.sass'
import { useUserActions } from 'src/hooks/api'
declare const window: any

const Associate = () => {
  const { id, secret } = useParams()
  const [status, setStatus] = useState('')
  const history = useHistory()
  const { associate } = useUserActions()

  useEffect(() => {
    setStatus('loading')
    associate(secret, id)
      .then(({email, secret}) => {
        setUserSecret(email, secret)
        history.replace('/')
      })
      .catch((e) => {
        setStatus('error')
        console.log(e)
      })
  }, [secret, id])


  return (
    <div id='associate' className='page split'>
      <header className='item left'>
        <div className='logo' />
      </header>
      <section className='item right'>
        <div className="wrapper">
          {status === 'loading'
            ? <Loading />
            : <div className='associate-error'>
                <h2>Error</h2>
                <p className='error-description'><FormattedMessage id="two-factor-associate.error" /></p>
                <button className='filled' onClick={() => history.replace('/')}>
                  <FormattedMessage id="two-factor-associate.error-go-home" />
                </button>
              </div>
          }
        </div>
      </section>
    </div>
  )
}

export default Associate
